import React, { useEffect, useState } from 'react';
import AppSelect from '../../../components/atoms/AppSelect/AppSelect';
import { AppMultiselect } from '../../../components/molecules/AppMultiselect/AppMultiselect';

export interface SelectProps {
  label: string;
  value: string;
}

export interface GeolocationFormState {
  countryCode: string;
  values: SelectProps[];
}

interface SwitchCriteriaFormProps {
  countries: SelectProps[];
  cities: SelectProps[];
  value?: GeolocationFormState;
  onChange: (e: GeolocationFormState) => void;
  citiesTitle: string;
}

export const GeolocationCriteriaForm = ({
                                          countries,
                                          cities,
                                          onChange,
                                          value,
                                          citiesTitle,
                                        }: SwitchCriteriaFormProps) => {
  const [formState, setFormState] = useState<GeolocationFormState>(value || {
    countryCode: countries[0].value,
    values: [],
  });

  useEffect(() => {
    onChange(formState);
  }, [formState]);

  return (
    <div className="flex w-full items-center gap-4">
      <div className={'min-w-72'}>
        <AppSelect options={countries} label={'Pais'} />
      </div>

      <label className={'min-w-72'}>
        {citiesTitle}
        <AppMultiselect key={formState.countryCode}
                        value={formState.values}
                        isSearchable
                        onChange={(values) => setFormState({ ...formState, values })}
                        options={cities} />
      </label>
    </div>
  );
};
